import { SPHERE } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyGeometryProperty, applyProperties } from './base';

export class Sphere extends BaseObject {
  constructor() {
    super(
      new THREE.SphereGeometry(SPHERE.RADIUS, SPHERE.WIDTH_SEGMENTS, SPHERE.HEIGHT_SEGMENTS),
      new THREE.MeshStandardMaterial({ color: SPHERE.COLOR })
    );

    this.radius = SPHERE.RADIUS;
    this.widthSegments = SPHERE.WIDTH_SEGMENTS;
    this.heightSegments = SPHERE.HEIGHT_SEGMENTS;
    this.phiStart = SPHERE.PHI_START;
    this.phiLength = SPHERE.PHI_LENGTH;
    this.thetaStart = SPHERE.THETA_START;
    this.thetaLength = SPHERE.THETA_LENGTH;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.SphereGeometry(
        this.radius,
        this.widthSegments,
        this.heightSegments,
        this.phiStart,
        this.phiLength,
        this.thetaStart,
        this.thetaLength
      );
      this.getOutline();
    };
    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      const needsUpdate =
        applyGeometryProperty(this, properties.radius, 'radius', SPHERE.MIN_RADIUS) |
        applyGeometryProperty(this, properties.widthSegments, 'widthSegments', SPHERE.MIN_SEGMENTS) |
        applyGeometryProperty(this, properties.heightSegments, 'heightSegments', SPHERE.MIN_SEGMENTS) |
        applyGeometryProperty(this, properties.phiStart, 'phiStart', SPHERE.MIN_ANGLE) |
        applyGeometryProperty(this, properties.phiLength, 'phiLength', SPHERE.MIN_ANGLE) |
        applyGeometryProperty(this, properties.thetaStart, 'thetaStart', SPHERE.MIN_ANGLE) |
        applyGeometryProperty(this, properties.thetaLength, 'thetaLength', SPHERE.MIN_ANGLE);

      if (needsUpdate) this.updateGeometry();
    };
  }

  getOutline() {
    this.removeOutline();
    // Don't use FLB edges for sphere — use screen-space outline pass instead
    this.userData.edgeOutline = false;
    this.userData.isSphere = true;
    this.traverse((child) => {
      child.userData.edgeOutline = false;
    });
  }
}
